import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Link } from 'react-router';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { actions as GroupMembers } from 'data/GroupMembers';
import { connect } from 'omni-common-ui';
import classnames from 'classnames';

import CourseViewTable from 'components/CourseViewTable';
import Styles from './style.postcss';
import {
  accessors,
  status,
} from 'data/WritingAssignment';

const statusStyle = {
  [status.NEW]: classnames(Styles.cell_status, Styles.cell_status_new),
  [status.INPROGRESS]: classnames(Styles.cell_status, Styles.cell_status_inprogress),
  [status.COMPLETE]: classnames(Styles.cell_status, Styles.cell_status_complete),
};

const DEFAULT_CELL = '-';
const movementLimit = 20;

const wasLeftMouseButtonPressed = (e = window.event) => {
  const button = e.which || e.button;
  return button === 1;
};

class CoreAndCatchUp extends PureComponent {
  constructor(props) {
    super(props);
    this._renderCell = this._renderCell.bind(this);
  }

  _onMouseDown(e) {
    if (! wasLeftMouseButtonPressed(e.nativeEvent)) return;
    this._startMouseX = e.screenX;
  }

  _onClick(e) {
    const movement = Math.abs(this._startMouseX - e.screenX);
    if (this._startMouseX && movement > movementLimit) {
      // x-axis drag happened; block click
      e.preventDefault();
      return false;
    }
  }

  _renderCell(member, lesson) {
    if (! member || ! lesson || ! lesson.studentActivities) return DEFAULT_CELL;
    const studentActivity = lesson.studentActivities.get(member.studentGeneralInfo.id);
    if (! studentActivity) return DEFAULT_CELL;
    return <Link className={Styles.cell}
        draggable={false}
        onMouseDown={(e) => this._onMouseDown(e)}
        onClick={(e) => this._onClick(e)}
        to={this._getDetailUrl(studentActivity.studentId, lesson.unitNo, lesson.lessonNo)}>
      <div className={Styles.cell_label}>
        {accessors.formatActivityType(studentActivity.activityType)}
      </div>
      <div className={statusStyle[studentActivity.status]}>
        {studentActivity.statusDisplayName}
      </div>
    </Link>;
  }

  _getDetailUrl(studentId, unitNo, lessonNo) {
    const { groupId } = this.props;
    const lessonSeq = this._getLessonSequence(unitNo, lessonNo);
    return `/group/${groupId}/writing-assignment` +
        `/lesson/${lessonSeq}` +
        `/student/${studentId}`;
  }

  _getLessonSequence(unitNo, lessonNo) {
    const lessonInfo = this.props.coreAndCatchUplessons.find((lesson) =>
        lesson.unitNo === unitNo && lesson.lessonNo === lessonNo);
    if (! lessonInfo) return '';
    return lessonInfo.seq;
  }

  _renderTableHeader(writingAssignmentListGroupByUnit = []) {
    return <CourseViewTable.Header>
      <CourseViewTable.Row>
        {
          writingAssignmentListGroupByUnit.map((val) =>
            <CourseViewTable.Cell colSpan={val.size} small>
              <span className={Styles.header}>{`Unit ${val.get(0).unitNo}`}</span>
            </CourseViewTable.Cell>)
        }
      </CourseViewTable.Row>
      <CourseViewTable.Row>
        {
          writingAssignmentListGroupByUnit.map((val) =>
            val.map((lesson) =>
              <CourseViewTable.Cell columnId={lesson} small>
                <span className={Styles.header}>{`${accessors.formatCategory(lesson.lessonCategory)}`}</span>
                <br />
                <span className={Styles.header}>{`Lesson ${lesson.lessonNo}`}</span>
              </CourseViewTable.Cell>)
          )
        }
      </CourseViewTable.Row>
    </CourseViewTable.Header>;
  }

  render() {
    const { members, writingAssignmentListGroupByUnit } = this.props;
    if (members && writingAssignmentListGroupByUnit) {
      return <CourseViewTable students={members}>
        {this._renderTableHeader(writingAssignmentListGroupByUnit)}
        <CourseViewTable.Body>
          {this._renderCell}
        </CourseViewTable.Body>
      </CourseViewTable>;
    }
    return <div />;
  }
}

CoreAndCatchUp.propTypes = {
  groupId: PropTypes.string.isRequired,
  members: PropTypes.array.isRequired,
  writingAssignmentListGroupByUnit: PropTypes.object,
  coreAndCatchUplessons: PropTypes.object,
};

export function mapStateToProps(state, ownProps) {
  const { groupId } = ownProps.params;
  const members = GroupMembers.getMembersByGroup(state, groupId);
  const coreWritingAssignmentList = accessors.getCoreWritingAssignment(state, groupId);
  const writingAssignmentListGroupByUnit = coreWritingAssignmentList &&
    coreWritingAssignmentList.groupBy((x) => x.unitNo);
  const coreAndCatchUplessons = accessors.getCoreWritingAssignmentLessons(state, groupId);
  return {
    members,
    groupId,
    writingAssignmentListGroupByUnit,
    coreAndCatchUplessons,
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({},
    { pushRoute: (path) => dispatch(push(path)) },
    bindActionCreators(GroupMembers, dispatch),
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CoreAndCatchUp);



// WEBPACK FOOTER //
// ./containers/Group/WritingAssignment/CoreAndCatchUp/component.jsx